import React from 'react';
import PropTypes from 'prop-types';
import plusImage from '../../images/plus_blue.svg';

function AddNewButton({ handleAction, text }) {
  return (
    <a className='add-new-button' onClick={handleAction} role='button' tabIndex={0}>
      <span>{text}</span> <img alt='Add New' src={plusImage} />
    </a>);
}

AddNewButton.propTypes = {
  handleAction: PropTypes.func,
  text: PropTypes.string,
};

AddNewButton.defaultProps = {
  handleAction: () => {},
  text: 'Add new',
};

export default AddNewButton;



// WEBPACK FOOTER //
// ./src/views/Components/AddNewButton.js